import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../store/authStore";
import { authApi } from "../../api/auth";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/Input";
import theme from "../../themes";

export default function LoginPage() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuthStore();
  const navigate = useNavigate();

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center p-4"
      style={{ backgroundImage: "url('/backgrounds/login_bg.png')", backgroundSize: "cover", backgroundPosition: "center" }}>
      {/* dark overlay so the card stays readable */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900/80 via-bh-950/75 to-gray-900/80" />
      <div className="relative z-10 w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3">
            {theme.headerLogo && (
              <img src={theme.headerLogo.src} alt={theme.headerLogo.alt} className="h-9 w-auto" />
            )}
            <h1 className="text-3xl font-bold text-bh-400 tracking-tight">{theme.appName}</h1>
          </div>
          {theme.poweredBy && (
            <div className="flex items-center justify-center gap-1.5 mt-1.5">
              <span className="text-gray-400 text-sm">{theme.poweredBy.label}</span>
              <a href={theme.poweredBy.href} target="_blank" rel="noopener noreferrer"
                 className="hover:opacity-70 transition-opacity">
                <img src={theme.poweredBy.logo} alt={theme.poweredBy.alt}
                     className="h-4 w-auto"
                     style={{ filter: "brightness(0) invert(1)", opacity: 0.75 }} />
              </a>
            </div>
          )}
          <p className="text-gray-500 text-xs mt-1">Pump Engineering Platform</p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <form onSubmit={submit} className="space-y-4">
            <Input label="Email" type="email" value={form.email} onChange={set("email")}
                   placeholder="ada@example.com" required />
            <Input label="Password" type="password" value={form.password} onChange={set("password")}
                   placeholder="••••••••" required />

            {error && (
              <div className="bg-red-50 border border-red-200 rounded-lg px-4 py-2.5 text-sm text-red-600">
                {error}
              </div>
            )}

            <Button type="submit" className="w-full justify-center" loading={loading}>
              Sign in
            </Button>
          </form>

          {/* Divider */}
          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-200" />
            </div>
            <div className="relative flex justify-center text-xs text-gray-400">
              <span className="bg-white px-3">or continue with</span>
            </div>
          </div>

          <button
            onClick={authApi.microsoftLogin}
            className="w-full flex items-center justify-center gap-2 px-4 py-2.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
          >
            SSO
          </button>
        </div>
      </div>
    </div>
  );
}
